import styled from "@emotion/styled";
import { Button, Card } from "@mui/material";

export const CampaignShippingContainer = styled.div(({ theme }) => ({
	margin: "16px",
	backgroundColor: "#f7f7f7",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	"h2, h3, p": { margin: 0 },
	h2: { ...theme.project.typography.heading.h4 },
	h3: { ...theme.project.typography.heading.h5, fontWeight: 300 }
}));

export const KitCard = styled(Card)(({ theme }) => ({
	borderRadius: 0,
	padding: "12px 20px",
	display: "grid",
	gridTemplateColumns: "minmax(160px, 2fr) 120px repeat(3, minmax(90px, 1fr))",
	gap: "16px",
	alignItems: "center",
	img: { width: "100px", height: "70px", objectFit: "contain" },
	".campaign-kit-title": { ...theme.project.typography.subtitle.subtitle2, fontWeight: 700 },
	".campaign-kit-sku, .campaign-kit-label": { ...theme.project.typography.body.body2 },
	[theme.breakpoints.down("md")]: { gridTemplateColumns: "minmax(150px, 2fr) 100px repeat(3, 1fr)", gap: "8px" },
	[theme.breakpoints.down("sm")]: {
		padding: "12px 8px",
		gridTemplateColumns: "1fr 100px",
		".campaign-kit-image": { gridColumn: "2", gridRow: "1 / span 2" },
		".campaign-kit-meta": { gridColumn: "span 1" }
	}
}));

export const ShippingCard = styled(Card)(({ theme }) => ({
	borderRadius: 0,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	".address-row, .contact-row": { display: "flex", gap: "16px", alignItems: "end" },
	".address-row > div, .contact-row > div": { flex: 1 },
	".add-address": { display: "flex", justifyContent: "flex-end" },
	[theme.breakpoints.down("md")]: { ".address-row, .contact-row": { flexDirection: "column", alignItems: "stretch" } }
}));

export const PlaceOrderButton = styled(Button)(({ theme }) => ({
	alignSelf: "flex-end",
	minWidth: "142px",
	[theme.breakpoints.down("sm")]: { alignSelf: "stretch", width: "100%" }
}));
